import { PaperComponent } from "@/components";
import { CurrencyConverter, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const OfferSelectionBody = ({
  offerData,
  selectedItem,
  updateOfferSliderData,
}) => {
  const t = useTranslations("offers.offerbody");
  const f = useTranslations("ApplyLoan");
  const InfoRow = ({ label, value }) => (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="h6" color={WEB_COLORS.textFadeColor}>
        {label}
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        {value}
      </Typography>
    </Stack>
  );
  return (
    <PaperComponent>
      <Stack spacing={2} p={2}>
        <InfoRow
          label={f("tenure")}
          value={`${updateOfferSliderData?.tenure || selectedItem?.tenure} ${f(
            "months",
          )}`}
        />
        <InfoRow
          label={t("emiamount")}
          value={CurrencyConverter(
            updateOfferSliderData?.emi || selectedItem?.emi,
          )}
        />
        <InfoRow
          label={t("interestrate")}
          value={`${
            updateOfferSliderData?.interestRate || selectedItem?.interestRate
          }% ${t("perannum")}`}
        />
        <InfoRow
          label={t("processingfee")}
          value={`${
            updateOfferSliderData?.processingFee || offerData?.processingFee
          }%`}
        />
        {/* <InfoRow
          label="Disbursement Amount"
          value={CurrencyConverter(disbursementAmount)}
        />
        <InfoRow
          label="Repayment Amount"
          value={CurrencyConverter(repaymentAmount)}
        /> */}
      </Stack>
    </PaperComponent>
  );
};

export default OfferSelectionBody;
